import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { useLang } from 'app/context/i18n';

import 'app/components/ChristmasBanner/ChristmasBanner.scss';

export default function ChristmasBanner() {
  const intl = useIntl();
  const locale = useLang();

  const handleClick = () => {
    window.location.replace(
      `https://www.bigbuy.eu/${locale}/integraciones-mip.html`
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  const plainText = intl
    .formatMessage({
      id: 'controlpanel.my_account.summary.christmas'
    })
    .replace(/<[^>]*>/g, '');

  return (
    <div
      className="bb-christmas-banner"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={plainText}
    >
      <p className="bb-christmas-banner__text">
        <FormattedMessage
          id="controlpanel.my_account.summary.christmas"
          values={{
            b: (...chunks) => <b>{chunks}</b>
          }}
        />
      </p>
    </div>
  );
}
